//https://www.algolia.com/doc/ui-libraries/autocomplete/api-reference/autocomplete-js/autocomplete/
import React from 'react'
import { getAlgoliaFacets } from '@algolia/autocomplete-js'
import AutoCompleteResultItem from './AutoCompleteResultItem'
import { algoliaClient } from '../../lib/algolia'
import AutocompleteListHeader from './AutocompleteListHeader'
import onItemSelect from './onItemSelect'
import generateBrowsePageUrl from '../../utils/search/generateBrowsePageUrl'

export const TAXONOMY_SEARCH_SOURCE_ID = 'taxonomySearch'

const generateAutocompleteFacetSource = ({
  indexName,
  facetsToSearch = [],
  headerTitle
}) => ({
  sourceId: TAXONOMY_SEARCH_SOURCE_ID,
  getItems({ query, setContext }) {
    if (!query) {
      return []
    }
    return getAlgoliaFacets({
      searchClient: algoliaClient,
      queries: facetsToSearch.map((facet) => ({
        indexName,
        facet: facet.name,
        params: {
          facetQuery: query,
          maxFacetHits: facet.limit,
          highlightPreTag: '<em>',
          highlightPostTag: '</em>'
        }
      })),
      transformResponse({ facetHits }) {
        const results = facetHits
          .map((results, index) =>
            results.map((result) => ({
              ...result,
              ...facetsToSearch[index],
              type: facetsToSearch[index].name
            }))
          )
          .flat()
          .sort((a, b) => b.count - a.count)
          .map((facet) => {
            const referral = 'searchboxHero-overviewMenu'
            const addReferralToUrl = (url) => `${url}&referral=${referral}`
            const slug = addReferralToUrl(
              generateBrowsePageUrl({
                [facet.name]: facet.label,
                locations: 'United States'
              })
            )

            return {
              ...facet,
              slug
            }
          })
          .slice(0, 10)
        const noResults = results.length === 0
        setContext({ increaseLocationsLimit: noResults })

        return results
      }
    })
  },
  onSelect: onItemSelect,
  templates: {
    header() {
      return headerTitle ? <AutocompleteListHeader title={headerTitle} /> : null
    },
    item({ item }) {
      return (
        <AutoCompleteResultItem
          result={item}
          className="max-h-[88px] px-4 py-[10px]"
        />
      )
    }
  }
})

export default generateAutocompleteFacetSource
